import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {routePath, utf8Decode} from "sdv-common";
import {User} from "../model/user.model";
import {Router} from "@angular/router";
import {getBrowserName, keys, reload} from "../shared/constants";
import {CookieService} from 'ngx-cookie-service';

@Injectable({providedIn: 'root'})
export class UserService {

  public resetPwdAttrId = 3;

  currentUser: User;

  constructor(private router: Router,
              private cookieService: CookieService,
              private apiService: ApiService) {
    if (this.apiService.isAuthorized()) {
      this.getUser(this.apiService.getJwtToken().sub)
        .then((user: User) => {
          this.currentUser = user;

          if (this.router.url !== '/profile') {
            for (const attribute of user.attributes) {
              if (attribute.code === this.resetPwdAttrId) {
                reload(routePath.profile);
              }
            }
          }
        });
    }
  }

  getCurrentUser() {
    return this.currentUser || this.convertUser({});
  }

  getUser(id) {
    return new Promise((resolve, reject) => {
      this.apiService.get('users/' + id)
        .subscribe((dto) => {
          resolve(this.convertUser(dto));
        }, err => {
          reject(err);
        });
    });
  }

  changePassword(id, request) {
    return new Promise((resolve, reject) => {
      this.apiService.patch('users/' + id, request)
        .subscribe(() => {
          resolve({});
        }, err => {
          reject(err);
        });
    });
  }

  edit(id, request) {
    return new Promise((resolve, reject) => {
      this.apiService.put('users/' + id, request)
        .subscribe(() => {
          resolve({});
        }, err => {
          reject(err);
        });
    });
  }

  private convertUser(dto) {
    return {
      created: dto.createdMillis || 0,
      id: utf8Decode(dto.id || ''),
      login: utf8Decode(dto.login || ''),
      lastName: utf8Decode(dto.lastName || ''),
      firstName: utf8Decode(dto.firstName || ''),
      middleName: utf8Decode(dto.middleName || ''),
      displayName: utf8Decode(dto.displayName || ''),
      attributes: (dto.attributes || []).map(n => ({
        created: n.createdMillis || 0,
        id: utf8Decode(n.id || ''),
        value: n.value,
        code: n.code
      }))
    };
  }

  auth(auth) {
    return new Promise((resolve, reject) => {
      this.apiService.post('users/auth',
        {
          contact: auth.contact,
          password: auth.password,
          browser: getBrowserName(),
          device: '',
          ip: '',
          os: ''
        })
        .subscribe(res => {
          const expires = new Date();
          expires.setDate(expires.getDate() + 1);
          this.cookieService.set(keys.sid, res.value, expires);
          reload(routePath.home);
          resolve({});
        }, err => {
          this.apiService.error(auth, err);
          reject(err);
        });
    });
  }
}
